import cryptoJs from 'crypto-js'
const config = {
    key: 'server_date_time',
    iv: 'client_date_time'
}
// 加密
export const encryptAes = (word, keyStr = config.key, ivStr = config.iv) => {
    let iv = cryptoJs.enc.Utf8.parse(ivStr)
    let key = cryptoJs.enc.Utf8.parse(keyStr)
    var srcs = cryptoJs.enc.Utf8.parse(word)
    var encrypted = cryptoJs.AES.encrypt(srcs, key, {
        iv,
        mode: cryptoJs.mode.CBC,
        padding: cryptoJs.pad.Pkcs7
    })
    return encrypted.toString()
}

// 解密
export const decryptAes = (word, keyStr = config.key, ivStr = config.iv) => {
    let iv = cryptoJs.enc.Utf8.parse(ivStr)
    var key = cryptoJs.enc.Utf8.parse(keyStr)
    var decrypt = cryptoJs.AES.decrypt(word, key, {
        iv,
        mode: cryptoJs.mode.CBC,
        padding: cryptoJs.pad.Pkcs7
    })
    return cryptoJs.enc.Utf8.stringify(decrypt).toString()
}

// DES加密
export const encryptDes1 = (message, key = 'leosys@deskey') => {
    var keyHex = cryptoJs.enc.Utf8.parse(key)
    var option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
    var encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
    return encrypted.toString() // 返回hex格式密文，如需返回base64格式：encrypted.toString()
}

// DES解密
export const decryptDes1 = (message, key = 'leosys@deskey') => {
    var keyHex = cryptoJs.enc.Utf8.parse(key)
    var decrypted = cryptoJs.DES.decrypt(
        {
            ciphertext: cryptoJs.enc.Hex.parse(message)
        }, // 若 message 是 base64 格式，则无需转16进制hex，直接传入 message 即可
        keyHex,
        {
            mode: cryptoJs.mode.ECB,
            padding: cryptoJs.pad.Pkcs7
        }
    )
    return decrypted.toString(cryptoJs.enc.Utf8)
}



// WEBPACK FOOTER //
// ./src/api/aes.js